
const modalPassword = (function(){
  return{
    init: function(){
      this.handModalPassword()
    },
    handModalPassword: function(){
      document.addEventListener('click', function(e){
        const el = e.target;
        const content =  document.querySelector('.password-modal__content');
        if(!content) return;
        if(el.classList.contains('modal__toggle-open')){  
          content.classList.remove('hidden');
         document.querySelector('html').classList.add('tp-over-flow-hidden');
        }
        if(el.classList.contains('password-modal__close')){
          content.classList.add('hidden');
          document.querySelector('html').classList.remove('tp-over-flow-hidden');
        }
      })
    }
  }
})();
modalPassword.init()